/**
 * Web service for fetching addresses based on a query string.
 *
 * Example output:
 *
 * curl https://api.dataforsyningen.dk/adgangsadresser?vejnavn=Aabogade&husnr=34&struktur=mini
 *
 * {
    "id": "0a3f5097-3266-32b8-e044-0003ba298018",
    "status": 1,
    "darstatus": 3,
    "vejkode": "9651",
    "vejnavn": "Åbogade",
    "adresseringsvejnavn": "Åbogade",
    "husnr": "34",
    "supplerendebynavn": null,
    "postnr": "8200",
    "postnrnavn": "Aarhus N",
    "stormodtagerpostnr": null,
    "stormodtagerpostnrnavn": null,
    "kommunekode": "0751",
    "x": 10.18832178,
    "y": 56.17211123,
    "href": "https://api.dataforsyningen.dk/adgangsadresser/0a3f5097-3266-32b8-e044-0003ba298018",
    "betegnelse": "Åbogade 34, 8200 Aarhus N"
  }
 */
import { WebServiceClient } from '../WebServiceClient'

export interface AddressResult {
  data?: {
    id: string
    vejnavn?: string
    husnr?: string
    postnr?: string
    postnrnavn?: string
    betegnelse?: string
    supplerendebynavn?: string
    x?: number
    y?: number
  }
  tekst?: string
}

export class Address extends WebServiceClient {
  static get URL (): string { return 'https://api.dataforsyningen.dk/autocomplete' }

  constructor () {
    const defaultParams = {
      srid: '25832',
      type: 'adresse',
      noFormat: '',
      struktur: 'mini',
      fuzzy: 'true',
      autocomplete: 'true'
    }
    super(Address.URL, defaultParams)
  }

  setQuery (query: string): void {
    this.addParam('q', query)
  }

  async fetchAddresses (): Promise<AddressResult[]> {
    const response: Response = await fetch(this.url())
    if (!response.ok) {
      throw new Error('Got invalid HTTP response.')
    }

    return await response.json()
  }
}
